module.exports = __webpack_public_path__ + "img/logo Wall Audit.8a0f606b.png";